import type { RenderLink } from '@ui/web/utils'
import { Button } from '@ui/web/components'
import { getStaticAssetUrl } from '@helper/utils/file'
import cn from '@config/tailwind/cn'

interface EmptyProps {
  type: 'web' | 'school'
  /**
   * General: you get href + children + className, you return your Link (TanStack `to`, Next `href`, etc.).
   * Example TanStack: renderLink={({ href, children, className }) => <Link to={href} className={className}>{children}</Link>}
   * Example Next: renderLink={({ href, children, className }) => <Link href={href} className={className}>{children}</Link>}
   */
  renderLink: RenderLink
}

export function Empty({ type, renderLink }: EmptyProps) {
  const buttonClassName = cn(type === 'web' && 'srd:bg-main-blue-20 srd:text-main-blue-100')

  const ctaContent = 'Jelajahi Perpustakaan'

  return (
    <div
      className={cn(
        'srd:w-full srd:flex srd:flex-col srd:items-center srd:justify-center srd:gap-y-2 srd:h-fit srd:min-h-[40dvh]',
        type === 'web' && 'srd:text-neutrals-white',
      )}
    >
      <img src={getStaticAssetUrl('illustration/alien.png')} alt='' width={60} height={60} draggable={false} />

      <h6 className='srd:font-medium'>Wah, kosong</h6>

      {type === 'school' && (
        <p>Simpan buku dari perpustakaan untuk akses dan atur bahan bacaan untuk pelajaran dengan mudah.</p>
      )}

      {type === 'web' && <p>Jelajahi dan simpan buku dari perpustakaan yuk!</p>}

      <Button asChild>{renderLink({ children: ctaContent, className: buttonClassName })}</Button>
    </div>
  )
}
